import { createContext, ReactNode, useContext } from "react";

import { useFilterVehicle } from "./filter-vehicle.hook";

const FilterVehicleContext = createContext(
  {} as ReturnType<typeof useFilterVehicle>
);
export function useFilterVehicleContext() {
  return useContext(FilterVehicleContext);
}

interface FilterVehicleProviderProps {
  children: ReactNode;
}
export function FilterVehicleProvider({
  children,
}: FilterVehicleProviderProps) {
  return (
    <FilterVehicleContext.Provider value={useFilterVehicle()}>
      {children}
    </FilterVehicleContext.Provider>
  );
}